import { autocompletePanel_MPG } from './autocomplete/brand-settings/mpg';
import { autocompletePanel_MMO } from './autocomplete/brand-settings/mmo';
import { autocompletePanel_MA } from './autocomplete/brand-settings/ma';

export const algoliaConfig = {
  mpg: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MPG_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MPG_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Trending',
      },

      initialProducts: {
        enabled: true,
        filter: 'tags:sortd-bestseller-150weeks',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    render: {
      autocomplete: autocompletePanel_MPG,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },



  mmo: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MMO_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MMO_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Trending',
      },

      initialProducts: {
        enabled: true,
        filter: 'tags:sortd-bestseller-150weeks',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    render: {
      autocomplete: autocompletePanel_MMO,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },




  ma: {
    algolia: {
      // Credentials pulled from Vite env vars (VITE_ prefix exposes to client bundle)
      appId: import.meta.env.VITE_ALGOLIA_MA_APP_ID,
      apiKey: import.meta.env.VITE_ALGOLIA_MA_API_KEY,
    },

    autocomplete: {
      productHitsPerPage: 12,
      debounceChars: 2,
      debounceMs: 700,

      suggestions: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Popular Searches',
      },

      initialProducts: {
        enabled: false,
        filter: '',
      },

      carouselResults: {
        enabled: true,
      },

      collectionPageResults: {
        enabled: true,
        hitsPerPage: 4,
        headerText: 'Collections & Pages',
        noResultsText: 'No products found.',
      },
    },

    render: {
      autocomplete: autocompletePanel_MA,
    },

    /**
     * onOpen — called once on first panel open (see autocomplete.js onStateChange).
     * Fetches initial content hits and returns them for carousel mounting.
     *
     * Only defined for brands that have content to pre-fetch. Brands that don't
     * simply omit this key — autocomplete.js handles the missing case via optional
     * chaining (config.onOpen?.()).
     *
     * @param {object} searchClient — algoliasearch/lite instance
     * @param {object} config — this brand's config object
     * @returns {Promise<Array>} Algolia hit objects
     */
    async onOpen(searchClient, config) {
      if (!config.autocomplete.initialProducts.enabled) return [];

      const { results } = await searchClient.search({
        requests: [{
          indexName: 'shopify_products',
          query: '',
          hitsPerPage: config.autocomplete.productHitsPerPage,
          filters: config.autocomplete.initialProducts.filter,
        }]
      });

      return results[0].hits;
    },
  },
};